module.exports = require("core-js-pure/stable/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols.js
// module id = 609
// module chunks = 0